module.exports = __webpack_public_path__ + "static/media/alert.8e8f1571.mp3";